/**
 * Do not edit directly
 * Generated on Wed, 22 Oct 2025 05:07:07 GMT
 */

module.exports = {
  "black-18a": "rgba(0, 0, 0, 0.18)",
  "black-8a": "rgba(0, 0, 0, 0.08)",
  "black-70a": "rgba(0, 0, 0, 0.7)",
  "black-12a": "rgba(0, 0, 0, 0.12)",
  "black-6a": "rgba(0, 0, 0, 0.06)",
  "black-4a": "rgba(0, 0, 0, 0.04)",
  "black-40a": "rgba(0, 0, 0, 0.4)",
  "black-90a": "rgba(0, 0, 0, 0.9)",
  "black-80a": "rgba(0, 0, 0, 0.8)",
  "black-60a": "rgba(0, 0, 0, 0.6)",
  "black-50a": "rgba(0, 0, 0, 0.5)",
  "black-24a": "rgba(0, 0, 0, 0.24)",
  "purple-500-90a": "rgba(186, 98, 253, 0.9)",
  "purple-500-20a": "rgba(186, 98, 253, 0.2)",
  "purple-600-10a": "rgba(122, 18, 212, 0.1)",
  "white-90a": "rgba(255, 255, 255, 0.9)",
  "white-24a": "rgba(255, 255, 255, 0.24)",
  "white-12a": "rgba(255, 255, 255, 0.12)",
  "white-70a": "rgba(255, 255, 255, 0.7)",
  "white-18a": "rgba(255, 255, 255, 0.18)",
  "white-8a": "rgba(255, 255, 255, 0.08)",
  "white-80a": "rgba(255, 255, 255, 0.8)",
  "white-60a": "rgba(255, 255, 255, 0.6)",
  "white-50a": "rgba(255, 255, 255, 0.5)",
  "white-40a": "rgba(255, 255, 255, 0.4)",
  "white-6a": "rgba(255, 255, 255, 0.06)",
  "white-4a": "rgba(255, 255, 255, 0.04)",
  "purple-tint": "#9b37f2",
  "yellow-50": "#fefae8",
  "yellow-100": "#fef7dc",
  "yellow-200": "#fcf1c5",
  "yellow-300": "#fae797",
  "yellow-400": "#f8dc69",
  "yellow-500": "#f5c918",
  "yellow-600": "#e8ad11",
  "yellow-700": "#c5930e",
  "yellow-800": "#97700b",
  "yellow-900": "#684e08",
  "orange-50": "#fff4e9",
  "orange-100": "#ffefdd",
  "orange-200": "#ffe4c7",
  "orange-300": "#ffce9a",
  "orange-400": "#ffb96d",
  "orange-500": "#ff931f",
  "orange-600": "#ed6325",
  "orange-700": "#c9541f",
  "orange-800": "#9a4018",
  "orange-900": "#6b2d11",
  "teal-50": "#ebfafb",
  "teal-100": "#e1f8f9",
  "teal-200": "#cdf3f5",
  "teal-300": "#a5eaed",
  "teal-400": "#7de0e4",
  "teal-500": "#37d0d6",
  "teal-600": "#1e9094",
  "teal-700": "#1a7a7e",
  "teal-800": "#145e60",
  "teal-900": "#0e4143",
  "aqua-50": "#eaf7ff",
  "aqua-100": "#dff4ff",
  "aqua-200": "#caecff",
  "aqua-300": "#a0ddff",
  "aqua-400": "#76ceff",
  "aqua-500": "#2cb3ff",
  "aqua-600": "#1b9ce6",
  "aqua-700": "#1785c3",
  "aqua-800": "#126596",
  "aqua-900": "#0c4668",
  "blue-50": "#ebf5ff",
  "blue-100": "#e0f0ff",
  "blue-200": "#cce6ff",
  "blue-300": "#a3d3ff",
  "blue-400": "#7abfff",
  "blue-500": "#329dff",
  "blue-600": "#005cff",
  "blue-700": "#1c3bd4",
  "blue-800": "#1832b4",
  "blue-900": "#12268a",
  "pink-50": "#feeaf3",
  "pink-100": "#fedfec",
  "pink-200": "#fdcae0",
  "pink-300": "#fca0c7",
  "pink-400": "#fa76af",
  "pink-500": "#f72c84",
  "pink-600": "#df1a6f",
  "pink-700": "#be165e",
  "pink-800": "#911148",
  "pink-900": "#640c32",
  "green-50": "#e8f9f1",
  "green-100": "#dcf6ea",
  "green-200": "#c5efdd",
  "green-300": "#97e3c1",
  "green-400": "#69d7a6",
  "green-500": "#18c176",
  "green-600": "#159f65",
  "green-700": "#128756",
  "green-800": "#0e6742",
  "green-900": "#09482d",
  "red-50": "#feeded",
  "red-100": "#fde3e3",
  "red-200": "#fcd1d1",
  "red-300": "#faacac",
  "red-400": "#f78787",
  "red-500": "#f34747",
  "red-600": "#d8273a",
  "red-700": "#b82131",
  "red-800": "#8c1926",
  "red-900": "#61121a",
  "purple-50": "#f8efff",
  "purple-100": "#f5e7ff",
  "purple-200": "#eed8fe",
  "purple-300": "#e0b8fe",
  "purple-400": "#d299fe",
  "purple-500": "#ba62fd",
  "purple-600": "#7a12d4",
  "purple-700": "#680fb4",
  "purple-800": "#4f0c8a",
  "purple-900": "#37085f",
  "cool-grey-100": "#f9f9f9",
  "cool-grey-150": "#f3f4f6",
  "cool-grey-200": "#ebedef",
  "cool-grey-250": "#dfe1e5",
  "cool-grey-300": "#ced1d7",
  "cool-grey-350": "#b3b8c1",
  "cool-grey-400": "#979ca5",
  "cool-grey-450": "#71767f",
  "cool-grey-500": "#595e67",
  "cool-grey-550": "#41464f",
  "cool-grey-600": "#292d38",
  "cool-grey-650": "#181d26",
  "cool-grey-700": "#0f131a",
  "black": "#000000",
  "white": "#ffffff"
};
